import { HttpClient, HttpEvent,HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, Input ,Output,EventEmitter, ChangeDetectorRef, } from '@angular/core';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { P30APIService } from 'src/app/core/services/api';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CalAngularService } from '@cvx/cal-angular';
import { Attachment } from 'src/app/core/interfaces/Attachment';
import { SV_USER, SV_USER_ROLE } from 'src/app/constants/constants';
import { SessionStorageService } from 'src/app/core/services/session_storage';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrl: './file-upload.component.css',
    standalone: false
})

export class FileUploadComponent {
  constructor(private http: HttpClient, private apiService: P30APIService,private session:SessionStorageService, private authService: CalAngularService, private msg: NzMessageService, private cdr: ChangeDetectorRef) { }

  @Output() isLoader = new EventEmitter<boolean>;
  @Input() islocalReviewer!: boolean | string;
  @Input() requestId: any;
  @Input() proposalId: any;
  files: Attachment[] = [];
  currentUserEmail = this.session.getItem(SV_USER).emailAddress;
  ngOnInit() {

    const regex = new RegExp('Reviewer');
    this.islocalReviewer = regex.test(this.session?.getItem(SV_USER_ROLE).roleTitle);
    this.getAttachments();
  }

  emitIsLoader(event:boolean){
    this.isLoader.emit(event);
  }

  // getFiles(): void {
  //   this.apiService.getFiles(this.requestId).subscribe(response => {
  //     this.files = [];
  //     if(response.body){
  //       const data = response.body['files']
  //       data.forEach((element: file_array) => {
  //         this.files.push(element)
  //       })
  //     }
  //   })
  // }
  getAttachments(): void {
    let proposal:any;
    this.isLoader.emit(true);this.apiService.getProposal(this.proposalId).subscribe({
      next: (event) => {
         proposal = event.body;
      },
      error: (err) => {
        console.log("Unable to retrieve proposal record from the database table ", err);
        this.isLoader.emit(false);
      },
      complete: () => {
        this.apiService.getAttachments(this.proposalId).subscribe(response => {
          this.files = [];
          if (response.body) {
            const data = response.body
            data.forEach((element: Attachment) => {
              this.files.push(element)
            })
          }
          if(this.islocalReviewer){
            //this.files = this.files.filter(x=>x.uploadedByEmail == this.session.getItem(SV_USER).emailAddress)
            this.files = this.files.filter(x=>x.uploadedByEmail != proposal.requestedByEmail)
          }
        })
      }
    });
    
    this.isLoader.emit(false);
  }

  nzAction = (item: any) => {
    this.isLoader.emit(true);
    return this.apiService.createAttachment(item.file, this.proposalId, "false", this.authService.cvxClaimsPrincipal.name!, this.authService.cvxClaimsPrincipal.email!, new Date().toLocaleString("en-US")).subscribe({
      next: (event: HttpEvent<any> | HttpResponse<any>) => {
        if (event instanceof HttpResponse) {
          console.log('File uploaded successfully');
        } else if (event.type === HttpEventType.UploadProgress) {
          const percentDone = Math.round(95 * event.loaded / event.total!);
          console.log(`Upload progress: ${percentDone}%`);
        }
      },
      error: (err) => {
        console.log(`Unable to upload file or create attachment record${err}`)
        this.isLoader.emit(false);
      },
      complete: () => {
        setTimeout(() => {
          this.cdr.detectChanges();
        }, 500);

        this.getAttachments();
        this.isLoader.emit(false);

      }
    })
  }

  // delete_file(fileName: any) {
  //   this.apiService.deleteFile(fileName, this.proposalId).subscribe({
  //     next: (output) => {
  //       if (output.status == 200) {
  //         console.log("file deleted successfully")
  //         this.getAttachments();
  //       }
  //     },
  //     error: (error) => {
  //       console.log('An error occured during file delete:', error);
  //     },
  //     complete: () => {
  //       console.log('completed the file delete process');
  //       this.cdr.detectChanges();
  //       // write the code to delete record from database
  //     }
  //   })
  // }
  deleteAttachment(fileName: any) {
    let attachmentId = this.files.filter(data => data.fileName==fileName)[0].attachmentId
    if(attachmentId){
      this.isLoader.emit(true);
      this.apiService.deleteAttachment(this.proposalId,attachmentId,fileName).subscribe({
        next: (output) =>{
          if(output.status==200){
            console.log("file deleted successfully")
          }
        },
        error: (error) => {
          console.log('An error occured during file delete:', error);
          this.isLoader.emit(false);
        },
        complete: () => {
          console.log('completed the file delete process');
          this.cdr.detectChanges();
          this.getAttachments();
          this.isLoader.emit(false);
          // write the code to delete record from database
        }
      })
    }
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }



}
